import { useEffect, useState } from "react";
import { IPanelRazonInsertar } from "./PanelRazonInsertar";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IRazonBody } from "../../../../../Interfaces/auxiliar/IRazon";
import { RazonService } from "../../../../../services/auxiliar/RazonService";
import { EstadoEquipoService } from "../../../../../services/auxiliar/estadoEquipoService";
import { IComboBoxOption } from "@fluentui/react";
import { CategoriaRazonService } from "../../../../../services/auxiliar/CategoriaRazonService";
import { Ifilter } from "../../../../../Interfaces/filter";

export const UsePanelRazonInsertar=(props:IPanelRazonInsertar)=>{
    const inital:IRazonBody={
        descripcion: "",
        codigo: "",
        estadoId:"",
        categoriaId:""
    }
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [request,setRequest]=useState<IRazonBody>(inital)
    const [estados,setEstados]=useState<IComboBoxOption[]>([])
    const [filterEstado, setfilterEstado] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [categorias,setCategorias]=useState<IComboBoxOption[]>([])
    const reset=()=>{
        setMensaje("")
        setRequest(inital)
        setStatus(0)
        props.onDismiss()
    }
    useEffect(()=>{
        if(props.isOpen){
            getEstados()
            getCategorias()
        }
    },[props.isOpen])
    const getEstados=()=>{
        EstadoEquipoService.ListarEstado(filterEstado).then((res)=>{
            setEstados(res.data)
        }).catch((e)=>{})
    }
    const getCategorias=()=>{
        const fil:Ifilter={
            skip: 0,
            take: 10
        }
        CategoriaRazonService.ComboCategoria(fil).then((res)=>{
            setCategorias(res.data)
        }).catch((e)=>{})
    }
    const required: (keyof IRazonBody)[] = [
        "descripcion",
        "codigo",
        "estadoId",
        "categoriaId"
      ];
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])
    const postInsertarRazon=()=>{
        setLoading(true)
        RazonService.CrearRazon(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,postInsertarRazon,loading,disableForm,reset,mensaje,status,estados,categorias}

}